var sko = require('./lib/safekeyobject.es6').default;

function check (hostmask, mapping) {
    hostmask = hostmask.toLowerCase();
    var hostParts = hostmask.split('@');
    var userParts = hostParts[0].split('!');

    var nick, user, host;
    if (hostParts[1]) {
        host = hostParts[1];
        if (userParts[1]) {
            user = userParts[1].replace(/^~/, '');
            nick = userParts[0];
        } else {
            user = userParts[0].replace(/^~/, '');
            nick = '*';
        }
    } else {
        // No username
        host = userParts[1];
        user = '*';
        nick = userParts[0];
    }

    var hostMap = new sko();
    _.each([mapping.get(host), checkWildcard(mapping, host).value, mapping.get('*')], function (uMap) {
        if (uMap) {
            uMap.each(function (u, nickMap) {
                hostMap.set(u, new sko().extend(hostMap.get(u), nickMap));
            });
        }
    });
    var userMap = new sko().extend(
        hostMap.get(user),
        checkWildcard(hostMap, user).value,
        hostMap.get('*')
    );

    return userMap.get(nick) ||
           checkWildcard(userMap, nick).value ||
           userMap.get('*') ||
           {match: false};
}

function checkWildcard (mapping, match) {
    return mapping.find(function (key, value) {
        if (key.length > 1 && key.indexOf('*') != -1) {
            // Swap * wildcards for .+ after escaping everything else for regex
            return match.match('^' + key.replace(/[-\[\]{}()+?.,\\\^$|#\s]/g, "\\$&").replace(/\*/g, '.*') + '$');
        }
    });
}

function parse (list) {
    var mapping = new sko({
        '*': new sko({
            '*': new sko()
        })
    });

    function set (host, user, nick) {
        mapping.get(host.toLowerCase())
            .get(user.toLowerCase())
            .set(nick.toLowerCase(), {
                match: true, host: host, user: user, nick: nick
            });
    }

    _.each(list, function (ignore) {
        var host = '*';
        var user = '*';
        var nick = '*';
        var ignoreParts = ignore.split('@');
        var usernickParts;
        if (ignoreParts.length == 2) {
            host = ignoreParts[1];
            usernickParts = ignoreParts[0].split('!');
            if (usernickParts.length == 2) {
                nick = usernickParts[0];
                user = usernickParts[1];
            } else {
                user = ignoreParts[0];
            }
        } else {
            usernickParts = ignore.split('!');
            if (usernickParts.length == 2) {
                nick = usernickParts[0];
                host = usernickParts[1];
            } else {
                nick = ignore;
            }
        }
        user = user.replace(/^~/, '');

        var userL = user.toLowerCase();
        var hostL = host.toLowerCase();

        if (host == '*') {
            if (user == '*') {
                if (nick == '*') {
                    // *!*@*
                    // unsupported
                } else {
                    // nick!*@*
                    set('*', '*', nick);
                }
            } else {
                if (!mapping.get('*').get(userL)) {
                    mapping.get('*').set(userL, new sko());
                }
                if (nick == '*') {
                    // *!user@*
                    set('*', user, '*');
                } else {
                    // nick!user@*
                    set('*', user, nick);
                }
            }
        } else {
            if (!mapping.get(hostL)) {
                mapping.set(hostL, new sko({
                    '*': new sko()
                }));
            }
            if (user == '*') {
                if (nick == '*') {
                    // *!*@host
                    set(host, '*', '*');
                } else {
                    // nick!*@host
                    set(host, '*', nick);
                }
            } else {
                if (!mapping.get(hostL).get(userL)) {
                    mapping.get(hostL).set(userL, new sko());
                }
                if (nick == '*') {
                    // *!user@host
                    set(host, user, '*');
                } else {
                    // nick!user@host
                    set(host, user, nick);
                }
            }
        }
    });
    return mapping;
}

module.exports = {
    check: check,
    parse: parse
};



//////////////////
// WEBPACK FOOTER
// ./app/src/ignore.js
// module id = pVJg
// module chunks = 1